import React from 'react';
import { CssBaseline, Box, Container, Grid } from '@mui/material';
import Hero from '../Layout/Banner';
import ArticleSection from './MainsiteSection';

function Trangchu() {
    const url = `${process.env.REACT_APP_STATIC_URL}/uploads/banner/banner_trangchu.png`;
    const title = 'KÝ SỰ LỊCH SỬ'
  return (
    <Box>
      <CssBaseline />
      <Hero url={url} title={title}/>
      <ArticleSection></ArticleSection>
    </Box>
  );
}

export default Trangchu;